import React from "react";
import "./App.css";
import {Outlet} from "react-router-dom";
import Header from "./components/header";
import usePageLoading from "./hooks/use-page-loading";
import {ThreeDots} from "react-loader-spinner";

function App() {
  const isLoading = usePageLoading();
  return (
    <main>
      <Header />
      {isLoading ? (
          <div className="layout-default">
        <ThreeDots
          visible={true}
          height="80"
          width="80"
          color="#FFD200"
          radius="9"
          ariaLabel="three-dots-loading"
          wrapperClass="full-layout"
        />
          </div>
      ) : (
        <Outlet></Outlet>
      )}
    </main>
  );
}

export default App;
